module.exports = __webpack_public_path__ + "static/scale-model-of-point-defiance-visitor-center-in-tacoma-washington-9e57cffbbce2cc7ddfea351ce4f20960.png";